import {
  requestGet,
  requestDelete,
  requestPost,
  requestPostFile,
  requestPutFile,
  requestPostFileBlob,
  requestPatch,
} from "../config/Api";

const name = "lawyer";

export const getLawyers = (params) => {
  return requestGet(name, { params });
};

export const createLawyer = (lawyer, isFile = false) =>
  requestPostFile(name, lawyer);

export const updateLawyer = (id, lawyer, isFile = false) =>
  requestPutFile(`${name}/${id}`, lawyer);

export const deleteLawyer = (id) => {
  return requestDelete(`${name}/${id}`);
};

export const pauseLawyerUpdates = (id) => {
  return requestPatch(`${name}/${id}/pause-updates`);
};

export const resumeLawyerUpdates = (id) => {
  return requestPatch(`${name}/${id}/resume-updates`);
};

export const captureLawyerSession = (id, { cookies, userAgent, enrollment }) => {
  return requestPost(`${name}/${id}/session/capture`, { cookies, userAgent, enrollment });
};

export const getLawyerSessionStatus = (id) => {
  return requestGet(`${name}/${id}/session/status`);
};

export const downloadLawyerDecree = async (patch) => {
  const response = await requestPostFileBlob(
    `lawyer/pdf/${encodeURIComponent(patch)}`,
  );
  return response;
};
